import { GuidettiWorld } from '@/guidetti/GuidettiWorld';
import Events from '@/services/Events';
import useConfigStore from '@/store/config.store';
import { storeToRefs } from 'pinia';

function useZoomControl() {
    const { isZoomed } = storeToRefs(useConfigStore());

    Events.on('zoomed', (e) => {
        if (e === 'true') {
            isZoomed.value = true;
        }
        if (e === 'false') {
            isZoomed.value = false;
        }
    });
    const limitRadius = 0.6;
    function zoom() {
        const { radius } = GuidettiWorld.instance?.camera ?? { radius: 0 };
        if (radius > 0.22) {
            GuidettiWorld.instance?.camera.setRadius(radius - 0.1);
        }
        if ((GuidettiWorld.instance?.camera.radius ?? 1) < limitRadius) {
            isZoomed.value = true;
        }
    }
    function unZoom() {
        const { radius } = GuidettiWorld.instance?.camera ?? { radius: 0 };
        if (radius < 0.9) {
            GuidettiWorld.instance?.camera.setRadius(radius + 0.1);
            if ((GuidettiWorld.instance?.camera.radius ?? 1) > limitRadius) {
                isZoomed.value = false;
            }
        }
    }
    function zoomMax() {
        isZoomed.value = true;
        GuidettiWorld.zoomOnPole();
    }
    function unZoomMax() {
        isZoomed.value = false;
        GuidettiWorld.zoomOnConfigPart();
    }
    function toggleZoom() {
        if (isZoomed.value) {
            unZoomMax();
            return;
        }
        zoomMax();
    }
    return { isZoomed, toggleZoom, zoom, unZoom, zoomMax, unZoomMax };
}

export { useZoomControl };
